import { getData, putData } from 'helpers/apiHelper';
import { MAIN_PATH, EMAIL_PREFERENCES_LIST, EMAIL_PREFERENCES_UPDATE } from './apiPath';

//get
export function getEmailPreferenceList(token, callback) {
  return getData(`${MAIN_PATH}${EMAIL_PREFERENCES_LIST}?token=${token}`)
}

//add
export function saveEmailPreference(token, id, payload) {
  return putData(`${MAIN_PATH}${EMAIL_PREFERENCES_UPDATE}/${id}?token=${token}`, payload)
}
